import { captureException } from '@sentry/nextjs'
import { useEffect, useState } from 'react'

export const useFullscreen = (
  elementReference: React.RefObject<HTMLElement | null>,
  callback?: () => void
) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const toggleFullscreen = () => {
    if (elementReference.current) {
      if (document.fullscreenElement) {
        void document.exitFullscreen()
      } else {
        elementReference.current.requestFullscreen().catch((error: unknown) => {
          captureException(error)
        })
      }
    }
  }

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement)
      callback?.()
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
    }
  }, [callback])

  return { isFullscreen, toggleFullscreen }
}
